import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const OfferWizardContext = createContext(null);

export const OfferWizardProvider = ({ children }) => {
    // Actions ref to store the current page's actions (next, save, etc.)
    // We use a ref so we don't trigger re-renders just by registering logic
    // But we might need re-renders if we want buttons to enable/disable.
    // Let's use state for safety to notify the wizard buttons.
    const [actions, setActions] = useState({
        onNext: null,
        onSave: null, // If explicit save is needed
        onPrev: null, // Usually just default nav, but can be overridden
        isSubmitting: false,
    });

    const setActionHandler = useCallback((newActions) => {
        setActions(prev => ({ ...prev, ...newActions }));
    }, []);

    const setIsSubmitting = useCallback((isSubmitting) => {
        setActions(prev => ({ ...prev, isSubmitting }));
    }, []);

    return (
        <OfferWizardContext.Provider value={{ actions, setActionHandler, setIsSubmitting }}>
            {children}
        </OfferWizardContext.Provider>
    );
};

export const useOfferWizard = () => {
    const context = useContext(OfferWizardContext);
    if (!context) {
        throw new Error('useOfferWizard must be used within an OfferWizardProvider');
    }
    return context;
};
